module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/Badges/Payments/Maestro-1eb35c86fa2c6eee33ab14fdeac05357.svg";